export const variables = [
	{
		field_name: "contract_date",
		description: "Պայմանագրի ամսաթիվ /Պայմանագրի ամսաթիվ / Ամսաթիվ",
		type: "calendar",
	},
	{
		field_name: "contract_number",
		description:
			" Պայմանագրի համարը հետևյալ ֆորմատով: Պայմանագրի հերթական համարը տվյալ ծրագրի համար / պայմանագրի_տարեթիվը-[ծրագրի համարը]",
		type: "autogenerated",
	},
	{
		field_name: "contract_location",
		description: "Պայմանագրի կնքման ամսաթիվը",
		type: "dropdown",
	},
	{
		field_name: "duration_of_support",
		description: "Աջձակցության ժամկետը",
		type: "number_input",
	},
	{
		field_name: "duration_of_support_with_words",
		description: "Աջձակցության ժամկետը բառերով",
	},
	// {
	// 	field_name: "project_name",
	// 	description: "Ծրագրի անվանումը",
	// 	type: "dropdown",
	// },
	{
		field_name: "each_month_duration",
		description: "Ամսեկան տևողությունը",
		type: "number_input",
	},
	{
		field_name: "each_month_duration_with_words",
		description: "Ամսեկան տևողությունը բառերով",
	},
	{
		field_name: "salary_for_employer",
		description: "Գործատույի ամսեկան վճարը",
		type: "number_input",
	},
	{
		field_name: "salary_for_employer_with_words",
		description: "Գործատույի ամսեկան վճարը բառերով",
	},
	{
		field_name: "salary_for_beneficiary",
		description: "Շահառույի ամսեկան վճարը",
		type: "number_input",
	},
	{
		field_name: "salary_for_beneficiary_with_words",
		description: "Շահառույի ամսեկան վճարը բառերով",
	},
	// {
	// 	field_name: "partner_organization_name",
	// 	description: "Իրավաբանական գործընկերոջ կազմակերպության անունը (ՍՊԸ, ԱՁ,․․․)",
	// 	type: "dropdown",
	// },
	{
		field_name: "partner_organization_head_position",
		description: "Իրավաբանական գործընկերոջ կազմակերպության պաշտոնը ",
	},
	{
		field_name: "partner_organization_head_name",
		description: "Իրավաբանական գործընկերոջ կազմակերպության ղեկավարի անուն ազգանունը ",
	},
	{
		field_name: "partner_organization_address",
		description: "Իրավաբանական գործընկերոջ կազմակերպության հասցեն",
	},
	{
		field_name: "partner_organization_tin",
		description: "Իրավաբանական գործընկերոջ կազմակերպության ՀՎՀՀ",
	},
	{
		field_name: "partner_organization_bank",
		description: "Իրավաբանական գործընկերոջ կազմակերպության բանկը",
	},
	{
		field_name: "partner_organization_bank_number",
		description: "Իրավաբանական գործընկերոջ կազմակերպության բանկի հաշվեհամար",
	},
	{
		field_name: "organization_address",
		description: "Կազմակերպության հասցե",
	},
	{
		field_name: "organization_head_name",
		description: "Կազմակերպության ղեկավարի անուն ազգանունը",
	},
	{
		field_name: "organization_name",
		description: "Կազմակերպության անվանումը",
	},
	{
		field_name: "organization_tinn",
		description: "Կազմակերպության ՀՎՀՀ",
	},
	{
		field_name: "delivery_time",
		description: "Մատակարարման ժամկետ",
		type: "text_input",
	},
	{
		field_name: "delivery_time_with_words",
		description: "Մատակարարման ժամկետ բառերով",
	},
	{
		field_name: "order_number",
		description:
			"Հրամանի համարի ֆորմատը։ հրամանի հերթական համարը / հրամանի_տարեթիվը հրամանի_տեսակը / *հրամանի_տեսակը = (Կ կամ Ա)",
		type: "autogenerated",
	},
	{
		field_name: "order_date",
		description: "Հրամանի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "order_location",
		description: "հրամանի կնքման վայրը",
		type: "dropdown",
	},
	{
		field_name: "partner_name",
		description: "Գործընկերոջ Անուն Ազգանունը",
		type: "dropdown",
	},
	{
		field_name: "vacation_start_date",
		description: "Արձակուրդի տրման ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "organization_hr_name",
		description: "Կազմակերպության ՄՌԿ պատասխանատույի անուն ազգանունը",
	},
	{
		field_name: "organization_accountant_name",
		description: "Կազմակերպության հաշվապահի անուն ազգանունը",
	},
	{
		field_name: "vacation_end_date",
		description: "Արձակուրդի տրման ամսաթիվը մինչև",
		type: "calendar",
	},
	{
		field_name: "working_day",
		description: "Արձակուրդում գտնվելու աշխատանքային օրերի քանակը",
		type: "text_input",
	},
	{
		field_name: "report_date",
		description: "Զեկուցագրի ամսաթիվ",
		type: "calendar",
	},
	{
		field_name: "position",
		description: "Հաստիք / Գործընկերոջ հաստիք",
		type: "dropdown",
	},
	{
		field_name: "start_date",
		description: "Պայմանագրի սկզբի ամսաթիվը",
		type: "text_input",
	},
	{
		field_name: "employee_name",
		description: " Ծրագրի Աշխատակից ում կողմից որ կազմվում է զեկուցագիրը",
		type: "text_input",
	},
	{
		field_name: "employee_project_name",
		description: "Տվյալ ծրագրի անվանումը, որի Աշխատակիցը կազմում է դիմումը",
	},
	{
		field_name: "employee_position",
		description: " Ծրագրի Աշխատակիցը / պաշտոնը",
	},
	{
		field_name: "partner_bank",
		description: "Գործընկերոջ  բանկի անունը",
	},
	{
		field_name: "partner_bank_account_number",
		description: "Գործընկերոջ բանկի հաշվեհամարը",
	},
	{
		field_name: "partner_location",
		description: "Գործընկերոջ  հասցեն",
	},
	{
		field_name: "partner_passport_number",
		description: "Գործընկերոջ անձնագրի կամ ID-ի համարը",
	},
	{
		field_name: "organization_tin",
		description: "Կազմակերպության ՀՎՀՀ",
	},
	{
		field_name: "number_of_additional_agreement",
		description:
			"Լրացուցիչ համաձայնագրի  համարը հետևյալ ֆորմատով: լրացուցիչ համաձայնագրի հերթական համարը տվյալ ծրագրի համար / պայմանագրի տարեթիվը-[ծրագրի համարը]",
	},
	{
		field_name: "date_of_additional_agreement",
		description: "Լրացուցիչ համաձայնագրի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "validity_date_of_additional_agreement",
		description: "ուժի մեջ մտնելու ամսաթիվը",
		type: "autogenerated",
	},
	{
		field_name: "location_of_additional_agreement",
		description: "location_of_additional_agreement",
		type: "dropdown",
	},
	{
		field_name: "end_date",
		description: "Պայմանագրի վերջի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "work_place",
		description: "Աշխատավայրը",
		type: "dropdown",
	},
	{
		field_name: "probation_period ",
		description: "Փորձաշրջան",
		type: "text_input",
	},
	{
		field_name: "work_day",
		description: "Աշխատանքային օր",
		type: "text_input",
	},
	// {
	// 	field_name: "busy_percentage ",
	// 	description: "զբաղվածության տոկոս",
	// 	type: "number_input",
	// },
	{
		field_name: "salary",
		description: "Գործընկերոջ (աշխատակցի) աշխատավարձը",
		type: "number_input",
	},
	{
		field_name: "salary_with_words",
		description: "ԱշխատավարձԻ չափը թվերով",
	},
	{
		field_name: "application_date",
		description: "Դիմումի Ամսաթիվ",
		type: "calendar",
	},
	{
		field_name: "date_of_dismissal ",
		description: "Ազատման ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "notification_date",
		description: "Ծանուցման ամսաթիվ",
		type: "calendar",
	},
	{
		field_name: "serive_quantity",
		description: "Պայմանագրով նախատեղված Մատուցվող ծառայության քանակ / Մատուցվող ծառայության քանակ",
		type: "text_input",
	},
	{
		field_name: "serive_quantity_with_words",
		description:
			"Պայմանագրով նախատեղված Մատուցվող ծառայության քանակը բառերով/ Մատուցվող ծառայության քանակը բառերով ",
	},
	{
		field_name: "unit_of_measurement",
		description: "Չափման միավորը",
		type: "dropdown",
	},
	{
		field_name: "each_service_salary",
		description: "Մատուցվող յուրաքանչյուր ծառայության արժեքը",
	},
	{
		field_name: "each_service_salary_with_words",
		description: "Մատուցվող յուրաքանչյուր ծառայության արժեքը բառերով",
		type: "text_input",
	},
	// {
	// 	field_name: "total_salary",
	// 	description: "Ընդանուր վճարը",
	// 	type: "total_salary = serive_quantity * each_service_salary",
	// },
	{
		field_name: "total_salary_with_words",
		description: "Ընդանուր վճարը բառերով",
	},
	{
		field_name: "act_date",
		description: "Ակտի ամսաթիվ Ամսաթիվ / Կնքված ակտի համարը",
		type: "text_input",
	},
	{
		field_name: "act_location",
		description: "Ակտի կնքման ամսաթիվը",
		type: "dropdown",
	},
	{
		field_name: "act_number",
		description: "Ակտի համար : ակտի հերթական համար/Պայամանագրի համարը /Կնքված ակտի համարը",
		type: "autogenerated",
	},
	{
		field_name: "act_start_date",
		description: "Ակտի սկիզբի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "act_end_date",
		description: "Ակտի վերջի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "provided_serive_quantity",
		description: "Արդեն մատուցված ծառայության քանակ",
		type: "text_input",
	},
	{
		field_name: "provided_serive_quantity_with_words",
		description: "Արդեն մատուցված ծառայության քանակը բառերով ",
	},
	// {
	// 	field_name: "provided_total_salary",
	// 	description: "Արդեն մատուցված ծառայությունների Ընդանուր վճարը",
	// 	type: "provided_total_salary = provided_serive_quantity * each_service_salary",
	// },
	{
		field_name: "provided_total_salary_with_words",
		description: "Արդեն մատուցված ծառայությունների Ընդանուր վճարը բառերով",
	},
	{
		field_name: "appendix_number",
		description: "Հավելվածի համարը",
		type: "autogenerated",
	},
	// {
	// 	field_name: "appendix_number_select",
	// 	description: "Հավելվածի համարը",
	// 	type: "dropdown",
	// },
	{
		field_name: "product_name",
		description: "Ապրանքի անվանում",
		type: "text_input",
	},
	{
		field_name: "product_details",
		description: "Ապրանքի բնութագիր",
		type: "text_input",
	},
	{
		field_name: "quantity",
		description: "քանակ",
		type: "text_input",
	},
	{
		field_name: "price_of_unit",
		description: "Միավորի արժեքը",
		type: "text_input",
	},
	{
		field_name: "comments",
		description: "Նշումներ",
		type: "text_input",
	},
	{
		field_name: "demand_letter_date",
		description: "պահանջագրի ամսաթիվը",
		type: "calendar",
	},
	{
		field_name: "demand_letter_number",
		description:
			"Պահանջագրի համարը։  Ֆորմատ՝  հերթական համար ընդհանուր բոլոր ծրագրերի համար / տարեթիվ",
		type: "autogenerated",
	},
	{
		field_name: "budget_line",
		description: "Բյուջեի տող",
		type: "dropdown",
	},
	{
		field_name: "advance_payment",
		description: "Կանխավճար",
		type: "text_input",
	},
	{
		field_name: "warranty_period",
		description: "Երաշխիքային ժամկետ",
		type: "text_input",
	},
	{
		field_name: "warranty_period_with_words",
		description: "Երաշխիքային ժամկետ բառերով",
	},
	{
		field_name: "final_payment",
		description: "Վերջնավճարի օր",
		type: "text_input",
	},
	{
		field_name: "final_payment_with_words",
		description: "Վերջնավճար բառերով",
	},
	{
		field_name: "address_for_work",
		description: "Կատարվող Աշխատանքների հասցե",
		type: "text_input",
	},
	{
		field_name: "volunteer_name",
		description: "Կամավորի անուն ազգանուն",
		type: "dropdown",
	},
	{
		field_name: "authorized_person",
		description: "Կամավորի լիազորված անձ",
	},
	{
		field_name: "authorized_person_passport",
		description: "Կամավորի լիազորված անձնագիր",
	},
	{
		field_name: "volunteer_birth_certificate",
		description: "Կամավորի ծննդյան վկայականի համար",
	},
	{
		field_name: "volunteer_date_of_birth",
		description: "Կամավորի ծննդյան ամսաթիվ",
	},
	{
		field_name: "volunteer_address",
		description: "Կամավորի կամավորի հասցե",
	},
];
